import { BUILD_ENV } from '@/config/build-env';
/** SIP URI domain in REGISTER / INVITE — must match the gateway hostname / TLS cert. */
const DEFAULT_SIP_DOMAIN_HOST = 'vcgateway.parsa.technology';
/** Asterisk / gateway WebSocket (browser uses `wss://`, not `https://`). */
const DEFAULT_SIP_WS_URL = 'wss://vcgateway.parsa.technology/ws';
export function sipWebSocketUrlFromEnv(staticDefault) {
    return BUILD_ENV.SIP_WS_URL || staticDefault;
}
export function sipDomainHostFromEnv(staticDefault) {
    return BUILD_ENV.SIP_DOMAIN_HOST || staticDefault;
}
/** Optional local-dev override when `.env` sets extension, password, and WebSocket URL. */
export function sipAccountFromBuildEnv() {
    const extension = BUILD_ENV.SIP_EXTENSION.trim();
    const password = BUILD_ENV.SIP_PASSWORD.trim();
    const sipWebSocketServerUrl = sipWebSocketUrlFromEnv(DEFAULT_SIP_WS_URL).trim();
    if (!extension || !password || !sipWebSocketServerUrl) {
        return null;
    }
    const authId = BUILD_ENV.SIP_AUTH_ID.trim() || extension;
    return {
        accountName: extension,
        callerId: extension,
        extension,
        authId,
        password,
        sipDomainHost: sipDomainHostFromEnv(DEFAULT_SIP_DOMAIN_HOST),
        sipWebSocketServerUrl,
    };
}
export function sipAorFromAccount(acc) {
    return `sip:${acc.extension}@${acc.sipDomainHost}`;
}
/** Build destination URI for keypad dial (`sip:user@domain`). */
export function sipDestinationUri(rawDialString, acc) {
    const t = rawDialString.trim();
    if (t.toLowerCase().startsWith('sip:')) {
        return t;
    }
    const userPart = t.replace(/[^\dA-Za-z+#*]/g, '');
    if (!userPart) {
        throw new Error('Enter a number or extension to dial.');
    }
    return `sip:${userPart}@${acc.sipDomainHost}`;
}
